<!-- <div class="gift-box-listing-item-container"> -->
    <img class="gift-box-image" src="{{ product.imageUrl }}">
    <div class="gift-box-product-label-container">
        <div class="gift-box-product-title"> {{ product.title }} </div>
        <div class="gift-box-product-brief" innerHTML="{{ product.description }}"></div>
        <div class="gift-box-product-price"> {{ product.price | price | translocoCurrency }} </div>
    </div>
<!-- </div> -->

<!-- <img class="gift-box-image-container" src="../../../../../assets/images/gift-box/2.jpg"> -->